import { useEffect } from "react"
import { CustomContainer, CustomDrawer } from "./styled-drawer/index.styles"

// Mui
import { Box, Stack, useTheme } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"

// components
import ScrollBar from "../../common/simple-bar"
import NavConfig from "./nav-config/index.jsx"
import Index from "./nav-items/index.jsx"
import StyledDrawer from "./styled-drawer"
// Next Router
import Link from "next/link"
import { useRouter } from "next/router"

import BasicLogo from "../../common/BasicLogo"

// ===============================================================================================

const MainDrawer = ({ open, handleDrawerToggle, window, drawerOpenMobile, setDrawer }) => {
  const router = useRouter()
  const theme = useTheme()
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"))

  useEffect(() => {
    if (open && matchDownMD) {
      setDrawer(false)
      handleDrawerToggle(!open)
    }
    setDrawer(false)
  }, [router.pathname])

  const navigationDrawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      <ScrollBar>
        <Stack direction='row' justifyContent='center' sx={{ my: 3, width: "100%" }}>
          <Link href='/'>
            <BasicLogo />
          </Link>
        </Stack>

        <Index sx={{ mx: 0 }} navConfig={NavConfig} />
      </ScrollBar>
    </Box>
  )

  return (
    <Box className='rere' component='nav' sx={{ flexShrink: { md: 0 }, zIndex: 1300 }} aria-label='main'>
      <CustomDrawer className='a1' open={drawerOpenMobile} onClose={() => handleDrawerToggle()}>
        {navigationDrawer}
      </CustomDrawer>
      <CustomContainer>
        <StyledDrawer variant='permanent' open={open}>
          {navigationDrawer}
        </StyledDrawer>
      </CustomContainer>
    </Box>
  )
}

export default MainDrawer
